import Permissions from "../../models/Permissions";

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/ApuracaoIRPJ",
    name: "Apuracao IRPJ",
    component: () => import("./Index.vue"),
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Apuração IRPJ/CSLL",
      icon: "fa fa-briefcase",
      group: "Contabil",
      permissions,
    },
  },
];
